import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";
import { HomePage } from "./pages/HomePage";
import LandingPage from "./pages/LandingPage";
import FormularioInteresse from "./pages/FormularioInteresse";
import { PlanosPage } from "./pages/PlanosPage";
import { ContatoPage } from "./pages/ContatoPage";
import { ReservaPage } from "./pages/ReservaPage";
import { FilaEsperaPage } from "./pages/FilaEsperaPage";
import { AdminDashboard } from "./components/admin/AdminDashboard";
import ClienteApp from "./components/cliente/ClienteApp";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";

const PublicLayout = ({ children }) => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="pt-24"> {/* Padding para navbar de 96px (h-24) */}
        {children}
      </div>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Landing page de conversão (redesign 2026-02) — agora é a home */}
            <Route path="/" element={<LandingPage />} />
            {/* Home antiga (backup — pode ser removida futuramente) */}
            <Route path="/home-antiga" element={
              <PublicLayout>
                <HomePage />
              </PublicLayout>
            } />
            <Route path="/planos" element={
              <PublicLayout>
                <PlanosPage />
              </PublicLayout>
            } />
            <Route path="/contato" element={
              <PublicLayout>
                <ContatoPage />
              </PublicLayout>
            } />
            <Route path="/reserva" element={
              <PublicLayout>
                <ReservaPage />
              </PublicLayout>
            } />
            <Route path="/fila-espera" element={
              <PublicLayout>
                <FilaEsperaPage />
              </PublicLayout>
            } />
            {/* Rota alternativa /lp aponta pra mesma landing (retrocompatibilidade) */}
            <Route path="/lp" element={<LandingPage />} />
            <Route path="/interesse" element={<FormularioInteresse />} />
            <Route 
              path="/admin/*" 
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
            <Route path="/cliente" element={<ClienteApp />} />
            <Route path="/cliente/*" element={<ClienteApp />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;console.log('SITE DINÂMICO CARREGADO - 202510030731');
